(function(){
function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
ready(function(){
  document.querySelectorAll('[data-ht-faq]').forEach(function(btn){
    btn.addEventListener('click',function(){
      var a=btn.parentElement.querySelector('.ht-faq__a');
      var open=!a.hasAttribute('hidden');
      document.querySelectorAll('.ht-faq__a').forEach(function(x){x.setAttribute('hidden','');});
      document.querySelectorAll('.ht-faq__sign').forEach(function(x){x.textContent='+';});
      if(!open){a.removeAttribute('hidden');btn.querySelector('.ht-faq__sign').textContent='\u2212';}
    });
  });

  var root=document.querySelector('[data-ht-buy]');
  if(!root)return;
  var variants=JSON.parse(root.getAttribute('data-variants'));
  var SINGLE=root.getAttribute('data-single');
  var BUNDLE=root.getAttribute('data-bundle');
  var SIZE=parseInt(root.getAttribute('data-bundle-size'),10)||4;
  var fmt=function(cents){return '\u20AE'+Math.round(cents/100).toLocaleString('en-US');};

  var colors=[];
  variants.forEach(function(v){if(v.o2&&colors.indexOf(v.o2)<0)colors.push(v.o2);});
  if(!colors.length)colors=[''];

  var state={pack:'bundle',color:colors[0],mix:{}};
  var left=SIZE;
  colors.forEach(function(c){state.mix[c]=0;});
  colors.forEach(function(c,i){var give=(i===0)?SIZE-(colors.length-1):1;if(give<0)give=0;state.mix[c]=give;});

  function find(packLabel,color){
    return variants.filter(function(v){
      return (!packLabel||v.o1===packLabel)&&(!color||v.o2===color||!v.o2);
    })[0];
  }
  var singleV=find(SINGLE,state.color);
  var singlePrice=singleV?singleV.price:0;
  var bundleV0=find(BUNDLE,state.color);
  var bundlePrice=bundleV0?bundleV0.price:singlePrice*SIZE;

  var elPriceS=root.querySelector('[data-ht-price-single]');
  var elPriceB=root.querySelector('[data-ht-price-bundle]');
  var elNote=root.querySelector('[data-ht-note]');
  var elTotal=root.querySelector('[data-ht-total]');
  var elSave=root.querySelector('[data-ht-save]');
  var elHint=root.querySelector('[data-ht-hint]');
  var elColors=root.querySelector('[data-ht-colors]');
  var elMix=root.querySelector('[data-ht-mix]');
  var elImg=root.querySelector('[data-ht-image]');
  var elAdd=root.querySelector('[data-ht-add]');

  if(elPriceS)elPriceS.textContent=fmt(singlePrice);
  if(elPriceB)elPriceB.textContent=fmt(bundlePrice);
  var saving=singlePrice*SIZE-bundlePrice;
  if(elNote)elNote.textContent=saving>0?('ХЭМНЭЛТ '+fmt(saving)):'';

  colors.forEach(function(c){
    var b=document.createElement('button');
    b.type='button';b.className='ht-chip';b.setAttribute('data-color',c);
    b.innerHTML='<span>'+c+'</span>';
    b.addEventListener('click',function(){state.color=c;render();});
    elColors.appendChild(b);
  });

  colors.forEach(function(c){
    var row=document.createElement('div');
    row.className='ht-mix__row';row.setAttribute('data-mix',c);
    row.innerHTML='<span class="ht-mix__label"><span class="ht-mix__name">'+c+'</span></span>'+
      '<span class="ht-mix__steps"><button type="button" class="ht-step" data-minus>\u2212</button>'+
      '<span class="ht-mix__count">0</span>'+
      '<button type="button" class="ht-step" data-plus>+</button></span>';
    row.querySelector('[data-minus]').addEventListener('click',function(){if(state.mix[c]>0){state.mix[c]--;render();}});
    row.querySelector('[data-plus]').addEventListener('click',function(){if(picked()<SIZE){state.mix[c]++;render();}});
    elMix.appendChild(row);
  });

  function picked(){var t=0;colors.forEach(function(c){t+=state.mix[c];});return t;}

  function render(){
    var isBundle=state.pack==='bundle';
    root.querySelectorAll('[data-ht-pack]').forEach(function(b){
      b.classList.toggle('is-active',b.getAttribute('data-ht-pack')===state.pack);
    });
    elColors.hidden=isBundle;
    elMix.hidden=!isBundle;
    left=SIZE-picked();
    if(elHint){
      elHint.textContent=isBundle?(left>0?('Дахин '+left+' ширхэг сонго'):(SIZE+' / '+SIZE+' сонгогдсон \u2713')):'';
      elHint.classList.toggle('is-done',left===0);
    }
    elColors.querySelectorAll('.ht-chip').forEach(function(b){
      b.classList.toggle('is-active',b.getAttribute('data-color')===state.color);
    });
    elMix.querySelectorAll('.ht-mix__row').forEach(function(row){
      var c=row.getAttribute('data-mix');
      row.classList.toggle('is-on',state.mix[c]>0);
      row.querySelector('.ht-mix__count').textContent=state.mix[c];
      row.querySelector('[data-minus]').disabled=state.mix[c]===0;
      row.querySelector('[data-plus]').disabled=left===0;
    });
    var total=isBundle?bundlePrice:singlePrice;
    if(elTotal)elTotal.textContent=fmt(total);
    if(elSave)elSave.textContent=(isBundle&&saving>0)?fmt(saving):'\u2014';
    var showColor=isBundle?dominant():state.color;
    var v=find(isBundle?BUNDLE:SINGLE,showColor);
    if(elImg&&v&&v.img)elImg.src=v.img;
    if(elAdd)elAdd.disabled=isBundle&&left!==0;
  }

  function dominant(){
    var best=colors[0];
    colors.forEach(function(c){if(state.mix[c]>state.mix[best])best=c;});
    return best;
  }

  root.querySelectorAll('[data-ht-pack]').forEach(function(b){
    b.addEventListener('click',function(){state.pack=b.getAttribute('data-ht-pack');render();});
  });

  if(elAdd)elAdd.addEventListener('click',function(){
    var isBundle=state.pack==='bundle';
    var color=isBundle?dominant():state.color;
    var v=find(isBundle?BUNDLE:SINGLE,color);
    if(!v)return;
    var props={};
    if(isBundle){
      var parts=[];
      colors.forEach(function(c){if(state.mix[c]>0)parts.push(state.mix[c]+'\u00D7'+c);});
      props['Багцын сонголт']=parts.join(', ');
    }
    elAdd.disabled=true;elAdd.textContent='НЭМЭГДЭЖ БАЙНА...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:v.id,quantity:1,properties:props}]})})
      .then(function(r){if(!r.ok)throw new Error('add failed');return r.json();})
      .then(function(){window.location.href='/cart';})
      .catch(function(){elAdd.disabled=false;elAdd.textContent='САГСАНД НЭМЭХ';alert('Сагсанд нэмэхэд алдаа гарлаа. Барааны нөөц болон төлөвийг шалгана уу.');});
  });

  render();
});
})();